/***************/
/**  IMPORTS  **/
/***************/
import { QueryClientProvider } from 'react-query';
import { useState, useEffect } from 'react';
import Cookies from "universal-cookie";
import { RiCloseLine } from "react-icons/ri";
import { useQuery } from 'react-query';
import { get } from 'aws-amplify/api';

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { 
    DarkBG,
    Centered,
    TheModal,
    ModalHeader,
    Heading,
    ModalContent,
    CloseButton,
} from '../styles/PDFOptionsModalStyles';
import { PDFLink } from "../styles/MapPageStyles";
import CastroPDF from "./pdf_components/street_pdfs/CastroPDF";
import DivisaderoPDF from "./pdf_components/street_pdfs/DivisaderoPDF";
import VanNessPDF from "./pdf_components/street_pdfs/VanNessPDF";
import UnionPDF from './pdf_components/street_pdfs/UnionPDF';
import FillmorePDF from './pdf_components/street_pdfs/FillmorePDF';
import ChestnutPDF from './pdf_components/street_pdfs/ChestnutPDF';
import PolkPDF from './pdf_components/street_pdfs/PolkPDF';
import MissionPDF from './pdf_components/street_pdfs/MissionPDF';
import ColumbusPDF from './pdf_components/street_pdfs/ColumbusPDF';
import ValenciaPDF from './pdf_components/street_pdfs/ValenciaPDF';
import LombardPDF from './pdf_components/street_pdfs/LombardPDF';
import HayesPDF from './pdf_components/street_pdfs/HayesPDF';
import GearyBlvdPDF from './pdf_components/street_pdfs/GearyBlvdPDF';
import GearyStPDF from './pdf_components/street_pdfs/GearyStPDF';
import GrantPDF from './pdf_components/street_pdfs/GrantPDF';
import PostPDF from './pdf_components/street_pdfs/PostPDF';
import PresidioPDF from './pdf_components/street_pdfs/PresidioPDF';
import SacramentoPDF from './pdf_components/street_pdfs/SacramentoPDF';
import TwentyFourthPDF from './pdf_components/street_pdfs/TwentyFourthPDF';
import ClementPDF from './pdf_components/street_pdfs/ClementPDF';
import IrvingPDF from './pdf_components/street_pdfs/IrvingPDF';
import JeffersonPDF from './pdf_components/street_pdfs/JeffersonPDF';
import HaightPDF from './pdf_components/street_pdfs/HaightPDF';
import MarketPDF from './pdf_components/street_pdfs/MarketPDF';
import WPortalPDF from './pdf_components/street_pdfs/WPortalPDF';
import { useAddresses } from "../utils/LocationsContext";

export default function PDFOptionsModal({groupedAddresses, setGroupedAddresses, streetname, setOpenPDFSettings, openPDFSettings, queryClient, pdfProps, flipped, setAllLocations, token}){

    const [highlightAvailableIsChecked, setHighlightAvailableIsChecked] = useState(false);
    const [highlightTempClosedIsChecked, setHighlightTempClosedIsChecked] = useState(false);
    // const [highlightBuildingForSale, setHighlightBuildingForSale] = useState(false);
    const [allTotalsAreChecked, setAllTotalsAreChecked] = useState(false);

    function abbreviateStreetName(streetName) {
        const abbreviations = {
            "Street": "St",
            "Avenue": "Ave",
            "Boulevard": "Blvd",
            "Place": "Pl",
            "Road": "Rd",
            "Drive": "Dr",
            "Court": "Ct",
            "Lane": "Ln",
            "Circle": "Cir",
            "Parkway": "Pkwy",
            "Square": "Sq"
        };

        if (!streetName || typeof streetName !== 'string') return "";

        const words = streetName.trim().split(" ");
        const lastWord = words[words.length - 1];

        if (abbreviations[lastWord]) {
            words[words.length - 1] = abbreviations[lastWord];
        }

        return words.join(" ");
    }

    /**  HANDLES GETTING ALL LOCATION DATA  **/
      const addresses = useQuery(['data', streetname], () => {
    
          async function getData(){
              // Create a get request to get all location data
              try{
                  const street_name = abbreviateStreetName(streetname);
                  const data = get({
                      apiName: 'LocationAPI',
                      path: `/location/all-data?streetname=${encodeURIComponent(street_name)}`,
                      options: {
                          headers: {
                              Authorization: `Bearer ${token}`
                          }
                      }
                  })
    
                  const { body } = await data.response;
                  const res = await body.json();
                  console.log('Getting all location data GET call succeeded for Map');
    
                  var locations = [];
                  // Get all the addresses into an array of JSON objects
                  for(var i = 0; i < res.addresses.length; i++) {
                      locations.push({address: res.addresses[i].address,
                                      name: res.addresses[i].businessName,
                                      id: res.addresses[i]._id});
                  }
                  setAllLocations(locations);
    
                  return res;
              } catch(e){
                  console.log('Getting all location data GET call failed for Map: ', e);
              }
          }
    
          if(token){
              return getData();
          }
      })

    useEffect(() => {
        setGroupedAddresses({});
      const addressList = Array.isArray(addresses?.data?.addresses) ? addresses?.data?.addresses : [];
      const grouped = {};
      const allNumbers = [];
  
      addressList.forEach(addressObj => {
          const buildingNumber = parseInt(addressObj.address.split(" ")[0], 10);
          allNumbers.push(buildingNumber);
          const hundredGroup = Math.floor(buildingNumber / 100) * 100; // Get the hundreds group
          const isEven = buildingNumber % 2 === 0;
          const groupKey = isEven ? "evens" : "odds";
  
          if (!grouped[hundredGroup]) {
              grouped[hundredGroup] = { odds: [], evens: [] };
          }
  
          grouped[hundredGroup][groupKey].push(addressObj);
      });
  
      if(flipped){
        // Sort descending addresses within each group
        Object.keys(grouped).forEach(hundred => {
          grouped[hundred].odds.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numB - numA;
          });
  
          grouped[hundred].evens.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numB - numA;
          });
      });
      } else {
        // Sort ascending addresses within each group
        Object.keys(grouped).forEach(hundred => {
          grouped[hundred].odds.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numA - numB; 
          });

          grouped[hundred].evens.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numA - numB;
          });
        });
      }
      

      if (allNumbers.length > 0) {
        const minGroup = Math.floor(Math.min(...allNumbers) / 100) * 100;
        const maxGroup = Math.floor(Math.max(...allNumbers) / 100) * 100;

        for (let group = minGroup; group <= maxGroup; group += 100) {
            if (!grouped[group]) {
                grouped[group] = { odds: [], evens: [] };
            }
        }
      }
  
      setGroupedAddresses(grouped);
      console.log("pdfmodal", grouped)
  }, [addresses?.data?.addresses]);
    
    const updatedPdfProps = {
        ...pdfProps,
        addresses,
        highlightAvailableIsChecked,
        highlightTempClosedIsChecked,
        // highlightBuildingForSale,
        allTotalsAreChecked
    };
    // Render map component based on street name
    const renderPDF = () => {
        switch (pdfProps.street) {
            case '24th Street':
                return <TwentyFourthPDF {...updatedPdfProps}/>;
            case 'Castro Street':
                return <CastroPDF {...updatedPdfProps}/>;
            case 'Chestnut Street':
                return <ChestnutPDF {...updatedPdfProps}/>;
            case 'Clement Street':
                return <ClementPDF {...updatedPdfProps}/>;
            case 'Columbus Avenue':
                return <ColumbusPDF {...updatedPdfProps}/>;
            case 'Divisadero Street':
                return <DivisaderoPDF {...updatedPdfProps}/>;
            case 'Fillmore Street':
                return <FillmorePDF {...updatedPdfProps}/>;
            case 'Geary Boulevard':
                return <GearyBlvdPDF {...updatedPdfProps}/>;
            case 'Geary Street':
                return <GearyStPDF {...updatedPdfProps}/>;
            case 'Grant Avenue':
                return <GrantPDF {...updatedPdfProps}/>;
            case 'Haight Street':
                return <HaightPDF {...updatedPdfProps}/>;
            case 'Hayes Street':
                return <HayesPDF {...updatedPdfProps}/>;
            case 'Irving Street':
                return <IrvingPDF {...updatedPdfProps}/>;
            case 'Jefferson Street':
                return <JeffersonPDF {...updatedPdfProps}/>;
            case 'Lombard Street':
                return <LombardPDF {...updatedPdfProps}/>;
            case 'Market Street':
                return <MarketPDF {...updatedPdfProps}/>;
            case 'Mission Street':
                return <MissionPDF {...updatedPdfProps}/>;
            case 'Polk Street':
                return <PolkPDF {...updatedPdfProps}/>;
            case 'Post Street':
                return <PostPDF {...updatedPdfProps}/>;
            case 'Presidio Avenue':
                return <PresidioPDF {...updatedPdfProps}/>;
            case 'Sacramento Street':
                return <SacramentoPDF {...updatedPdfProps}/>;
            case 'Union Street':
                return <UnionPDF  {...updatedPdfProps}/>;
            case 'Van Ness Avenue':
                return <VanNessPDF {...updatedPdfProps}/>
            case 'Valencia Street':
                return <ValenciaPDF {...updatedPdfProps}/>
            case 'W Portal Avenue':
                return <WPortalPDF {...updatedPdfProps}/>
            case undefined:
                return <UnionPDF  {...updatedPdfProps}/>;
        }
    };
    
    const handleClose = (e) => {
        e.stopPropagation();
        setOpenPDFSettings(false);
        document.body.style.overflow = 'unset';
    }

    const handleAvailableHighlightCheckBox = (e) => {
        setHighlightAvailableIsChecked(e.target.checked)
    }

    const handleTempClosedHighlightCheckBox = (e) => {
        setHighlightTempClosedIsChecked(e.target.checked)
    }

    // const handleBuildingForSaleCheckBox = (e) => {
    //     setHighlightBuildingForSale(e.target.checked)
    // }

    const handleTotalsCheckBox = (e) => {
        setAllTotalsAreChecked(e.target.checked)
    }

    return (
        <>
            <DarkBG onClick={() => {
                setOpenPDFSettings(false);
                document.body.style.overflow = 'unset';
                }} />
            <Centered>
                <TheModal>
                    <ModalHeader>
                        <Heading>PDF Settings</Heading>
                    </ModalHeader>
                    <CloseButton onClick={(e) => handleClose(e)}>
                            <RiCloseLine style={{height: "15px"}}/>
                        </CloseButton>
                    <ModalContent>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "300px"}}>
                                Display Total Stats?
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <input 
                                    type="checkbox" 
                                    checked={allTotalsAreChecked}
                                    onChange={handleTotalsCheckBox}/>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "300px"}}>
                                Highlight Available/Temporarily Closed Spaces?
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <input 
                                    type="checkbox" 
                                    checked={highlightAvailableIsChecked}
                                    onChange={handleAvailableHighlightCheckBox}/>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "300px"}}>
                                Highlight only Temporarily Closed Spaces?
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <input 
                                    type="checkbox" 
                                    checked={highlightTempClosedIsChecked}
                                    onChange={handleTempClosedHighlightCheckBox}/>
                            </div>
                        </div>
                        {/* HIGHLIGHT BUILDINGS FOR SALE*/}
                        {/* <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px"}}>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "30px", width: "300px"}}>
                                Highlight Buildings For Sale?
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <input 
                                    type="checkbox" 
                                    // checked={highlightBuildingForSale}
                                    onChange={handleBuildingForSaleCheckBox}/>
                            </div>
                        </div> */}
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "10px"}}>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                { Object.keys(groupedAddresses).length !== 0 && 
                                    <PDFLink document={<QueryClientProvider client={queryClient}>{renderPDF()}</QueryClientProvider>} fileName={`${streetname}.pdf`}>
                                        {({ blob, url, loading, error }) =>
                                        Object.keys(groupedAddresses).length === 0 ? 'Loading...' : 'Download PDF'
                                        }
                                    </PDFLink>}
                                    
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", fontSize: "14px", justifyContent: "center"}}>*To display only the map with no highlights, click Download PDF</div>
                    </ModalContent>
                </TheModal>
            </Centered>
        </>
    )
}